import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  createModel,
  getModel,
  getModels,
  editModel,
  deleteModel,
} from "api/modelApi"

export const MODEL_QUERY_KEY = "models"

export const useModels = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [MODEL_QUERY_KEY, params], // include params in the query key for caching
    queryFn: () => getModels(params),
    keepPreviousData: true, // optional, useful for pagination or filtering
    enabled,
  })
}

export const useModel = id => {
  return useQuery({
    queryKey: [MODEL_QUERY_KEY, id], // unique cache key
    queryFn: () => getModel(id),
    enabled: !!id, // only run if id is provided
  })
}

export const useCreateModel = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createModel,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([MODEL_QUERY_KEY]) // refresh models list
      }
    },
  })
}

export const useEditModel = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: editModel,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([MODEL_QUERY_KEY]) // refresh models list
      }
    },
  })
}

export const useDeleteModel = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteModel,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([MODEL_QUERY_KEY]) // refresh models list
      }
    },
  })
}
